module.exports = fox._r("fonts/iconfont.eot?ldnvmv", __webpack_public_path__ + "fonts/3NVCGBe.eot");


//////////////////
// WEBPACK FOOTER
// ./fonts/iconfont.eot?ldnvmv
// module id = 74
// module chunks = 4